import type { GalleryPreset } from "../types";

export const facultyTeachingPresets: GalleryPreset[] = [
  {
    presetId: "oxford-scholar",
    presetVersion: 1,
    name: "Oxford Scholar",
    tagline: "Authoritative, publication-priority layout for senior faculty and researchers",
    category: "faculty-teaching",
    filters: {
      purpose: "faculty-profile",
      aesthetic: "formal",
      contentEmphasis: ["publications", "teaching"],
      userStage: "professor",
    },
    intendedAudience: "Tenured professors, department chairs, and senior researchers",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/oxford-scholar.webp",
    structureId: "faculty-linear",
    themeId: "theme-oxford-navy",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-chen",
    isFeatured: true,
  },
  {
    presetId: "bento-professor",
    presetVersion: 1,
    name: "Bento Professor",
    tagline: "Modern asymmetric layout balancing lab identity, courses, and publications",
    category: "faculty-teaching",
    filters: {
      purpose: "faculty-profile",
      aesthetic: "modern",
      contentEmphasis: ["teaching", "projects", "publications"],
      userStage: "professor",
    },
    intendedAudience: "Associate and full professors managing active laboratories and courses",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/bento-professor.webp",
    structureId: "bento-grid",
    themeId: "theme-sapphire-modern",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-chen",
  },
  {
    presetId: "teaching-atelier",
    presetVersion: 1,
    name: "Teaching Atelier",
    tagline: "Course-first pedagogical presentation with warm editorial tone",
    category: "faculty-teaching",
    filters: {
      purpose: "teaching-focused",
      aesthetic: "editorial",
      contentEmphasis: ["teaching", "experience"],
      userStage: "professor",
    },
    intendedAudience: "Senior lecturers, teaching professors, and pedagogy directors",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/teaching-atelier.webp",
    structureId: "faculty-linear",
    themeId: "theme-botanical-warm",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-chen",
  },
  {
    presetId: "department-chair",
    presetVersion: 1,
    name: "Department Chair",
    tagline: "Executive split-column leadership layout with champagne-accented dark depth",
    category: "faculty-teaching",
    filters: {
      purpose: "academic-cv",
      aesthetic: "dark",
      contentEmphasis: ["experience", "grants", "publications"],
      userStage: "dept-head",
    },
    intendedAudience: "Department heads, deans, and institute directors",
    requiredTier: "premium",
    thumbnailUrl: "/thumbnails/department-chair.webp",
    structureId: "editorial-split",
    themeId: "theme-obsidian-executive",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-morrison",
    isFeatured: true,
  },
  {
    presetId: "distinguished-fellow",
    presetVersion: 1,
    name: "Distinguished Fellow",
    tagline: "Monumental serif presentation for endowed chairs and academy fellows",
    category: "faculty-teaching",
    filters: {
      purpose: "faculty-profile",
      aesthetic: "formal",
      contentEmphasis: ["publications", "awards"],
      userStage: "professor",
    },
    intendedAudience: "Endowed chairholders, national academy members, and fellows",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/distinguished-fellow.webp",
    structureId: "editorial-split",
    themeId: "theme-academic-royal",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-morrison",
  },
  {
    presetId: "clinical-educator",
    presetVersion: 1,
    name: "Clinical Educator",
    tagline: "High-density clean index for medical, clinical, and health sciences faculty",
    category: "faculty-teaching",
    filters: {
      purpose: "teaching-focused",
      aesthetic: "minimal",
      contentEmphasis: ["experience", "publications"],
      userStage: "professor",
    },
    intendedAudience: "Clinical professors, medical faculty, and residency directors",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/clinical-educator.webp",
    structureId: "faculty-linear",
    themeId: "theme-swiss-monochrome",
    blueprintId: "blueprint-faculty-standard",
    demoDataId: "persona-dr-brooks",
  },
];
